export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";